// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link, { LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import scrollToId from "@toolkit/Framework/Common/Utilities/scrollToId";
import { useAnchorContext } from "@toolkit/Framework/Components/AnchorContext";
import React, { FC } from "react";

interface OwnProps extends ExpandStyles<AnchorMenuStyles> {}

type Props = OwnProps;

export interface AnchorMenuStyles {
    wrapper?: InjectableCss;
    list?: InjectableCss;
    listItem?: TypographyPresentationProps;
    link?: LinkProps;
}

const anchorMenuStyle: AnchorMenuStyles = {};

const AnchorMenu: FC<Props> = ({ extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(anchorMenuStyle, extendedStyles, overridedStyles);
    const { links } = useAnchorContext();

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper as="ul" {...styles.list}>
                {links.map(({ id, label }) => {
                    return id && label ? (
                        <Typography key={id} forwardAs="li" {...styles.listItem}>
                            <Link onClick={() => scrollToId(id)} {...styles.link}>
                                {label}
                            </Link>
                        </Typography>
                    ) : null;
                })}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default AnchorMenu;
